// ------------------------------------
// props 輸入需求 : 
// props.data : object : { data: array }            (  )
// ------------------------------------

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ApiGo from '../../../../actions/ApiGo';
import { LogTime } from '../../../../actions/forFrontEnd_Log';
import UiIntegrater from '../littleUIComponent/UiIntegrater';
import StackedChart from './StackedChart';


const HISBedStateMR = (props) => {
    const { t } = useTranslation(); // 1.2 i18n
    // const [alertRow, setAlertRow] = useState([]);
    const id = props.data.id

    // 回傳值區
    const [returnShift, setReturnShift] = useState("ALL");
    // const [returnState, setReturnState] = useState("all");               // api return "bedStateAlertLevel"
    const [dateArr, setDateArr] = useState([]);
    const [alertArr_mon, setAlertArr_mon] = useState([]);

    // ------- redux --------------------
    const store_timestamp = useSelector(state => state.store_historyData.timestamp)

    useEffect(() => {
        if (store_timestamp.length === 0) return
        asyncInterface(id, store_timestamp, returnShift).then(res => {
            let _dar = res.map(_arr => new LogTime(new Date(_arr[0])).getShortDate())
            setDateArr(_dar)
            setAlertArr_mon(rotateMatrix(res))
        })
    }, [returnShift, store_timestamp]);
    // ------- redux --------------------

    function alertFilter(_alert) {
        let state1, state14, state217, state218, state12, state502, state504, state505,state511,state512 = [null, null, null, null, null, null, null, null,null,null]
        state1 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 1).length
        state14 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 14).length
        state217 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 217).length
        state218 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 218).length
        state12 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 12).length
        state502 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 502).length
        state504 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 504).length
        state505 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 505).length
        state511 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 511).length
        state512 = _alert.filter(_a => _a.bedStateAlertLevel === 2 && _a.bedState === 512).length
        return [state1, state14, state217, state218, state12, state502, state504, state505,state511,state512].map(value => value === 0 ? null : value)
    }

    function handleAlerts(id, timeStamp, shift) {
        return new Promise((resolve) => {
            let _a = []
            let _counter = 14
            for (let _d = 13; _d >= 0; _d--) {
                let _time = timeStamp - (_d * 86400000)
                let _date_obj = new Date(_time)
                let _date = new LogTime(_date_obj).getDate()
                ApiGo.getAlert(id, _date, shift)
                    .then(res => {
                        _counter--
                        _a.push([_time, alertFilter(res.alerts)])
                        if (_counter === 0) { resolve(_a) }
                    })
                    .catch(() => {
                        _counter--
                        _a.push([_time, [0, 0, 0, 0, 0]])
                        if (_counter === 0) { resolve(_a) }
                    })
            }
        })
    }

    async function asyncInterface(id, store, shift, state) {
        let a = await handleAlerts(id, store, shift, state)
        a.sort((a, b) => {
            return a[0] - b[0]
        })
        return a
    }

    function rotateMatrix(_alertArr) {
        let arr = [
            { name: '不在床上', data: [] },
            { name: '準備離床', data: [] },
            { name: '久臥', data: [] },
            { name: '離床過久', data: [] },
            { name: '坐起', data: [] }
        ]
        _alertArr.forEach(_arr => {
            arr[0]['data'].push(_arr[1][0] === 0 ? null : _arr[1][0]);
            arr[1]['data'].push(_arr[1][1] === 0 ? null : _arr[1][1]);
            arr[2]['data'].push(_arr[1][2] === 0 ? null : _arr[1][2]);
            arr[3]['data'].push(_arr[1][3] === 0 ? null : _arr[1][3]);
            arr[4]['data'].push(_arr[1][4] === 0 ? null : _arr[1][4]);
        });
        return arr
    }

    return (
        <>
            <UiIntegrater
                OnOff_switch={[true, true, false, true, true]}
                setReturnShift={setReturnShift}
                // setReturnState={setReturnState}
                name={(props.data !== undefined) ? props.data.last_name : ""}
                bed={(props.data !== undefined) ? props.data.first_name : ""}
            />
            {/* <div className="fx-d-c fx-9-i  npage"> */}
            <div className="fx-d-c h-90">
                <StackedChart data={alertArr_mon} dateArr={dateArr} />
            </div>
        </>
    );

}
export default HISBedStateMR;